export const environment = {
    BASE_URL: 'https://usa.test.satsangphilanthropy.com',
    // BASE_URL: 'http://localhost:6060',
    SSO_URL: 'https://sso2.test.satsang.org.in/',
    // localhostUrl: 'http://localhost:4200/login',  // [USE IT FOR DEVELOPMENT BUT NEVER PUSH]
    localhostUrl: 'https://usa.test.satsangphilanthropy.com/login',
    orgUrl: 'https://www.test.satsang.org.in',
    // accoUrl: 'https://dev.acco.satsang.org.in',
    ACTIVE_STATUS: 'Active',
    INACTIVE_STATUS: 'In-Active',
    REJECTED_STATUS: 'Rejected',
    PENDING_STATUS: 'Pending',
    activityLogoutTimeInMins: 60,
    production: false,
    stripe_publisher_key: 'pk_test_51Q1trI2Mb5kwBTVTvOZ11uk9pOFaQehfpMTKWodEH6SZBVGPZpPjPkvC2Tkp41KsYbrmTttuR3MzrFIGT3xClXxP00t7Qu62WR',
    IST_FORM: ['APRNM', 'DPRNM', 'PRVRT'],
    MISC_CODE_TYPE: ['MANDIR', 'MISC']
};
